import { IProductReviewActionState } from '../interfaces';

export const doUpdateProductReviewState = (state: IProductReviewActionState, newState: IProductReviewActionState): IProductReviewActionState => ({
    ...state,
    ...newState,
});

export const doUpdatePageLoading = (state: IProductReviewActionState, isPageLoading: boolean): IProductReviewActionState => ({
    ...state,
    isPageLoading,
});
